var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M50,14A36,36,0,1,0,86,50,36,36,0,0,0,50,14Zm0,67.5A31.5,31.5,0,1,1,81.5,50,31.53,31.53,0,0,1,50,81.5Zm2.25-49h-4.5V57h4.5ZM50,61.88a3.38,3.38,0,1,0,3.37,3.37A3.38,3.38,0,0,0,50,61.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleError);
export default __webpack_public_path__ + "static/media/CircleError.eb4fbcde42725eda0adceb3d28cf0276.svg";
export { ForwardRef as ReactComponent };